export const DirectionsColumns = [
    {
        name: 'Направление',
        key: 'direction',
    },
    {
        name: 'Статус',
        key: 'status',
    },
    {
        name: '1C код',
        key: 'code',
    },
    {
        name: 'Цена',
        key: 'price',
    },
    {
        name: 'Время доставки (в днях)',
        key: 'deliveryTime',
    },
    {
        name: 'Зона доставки',
        key: 'zoneId',
    },
    {
        name: 'Город-спутник',
        key: 'isNearbyCities',
    },
]

export const DirectionsCompaniesColumns = [
    {
        name: 'ID',
        key: 'id',
    },
    {
        name: 'Компания',
        key: 'company'
    },
    {
        name: 'Направление',
        key: 'direction'
    },
    {
        name: 'Статус',
        key: 'isActive'
    }
]
